<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol col="12" lg="3" class="align-self-center">
              Adverts
              <!-- <a href="/dashboard"><b>Back</b></a> -->
            </CCol>
            <CCol col="12" lg="9" class="align-self-center">
                <ul class="list-inline mb-0 text-lg-right filter-date-block">
                  <li class="list-inline-item align-middle mt-1 mb-1 ">
                    <datepicker :disabled-dates="disabledDates" :format="this.format" v-model="dateselection.datefrom" name="uniquename" class="form-control" placeholder="From date" @selected="enableDisabled();"></datepicker>
                    <div class="login-errors adverts-lists" v-if="$v.dateselection.datefrom.$error">
                      <span class="validation-error" v-if="!$v.dateselection.datefrom.required">Please Enter from date</span>
                    </div>
                  </li>
                  <li class="list-inline-item align-middle mt-1 mb-1 ">
                    <datepicker :disabled-dates="disabledDates" :format="this.format" v-model="dateselection.dateto" name="uniquename" class="form-control" placeholder="To date" @selected="enableDisabled();"></datepicker>
                    <div class="login-errors adverts-lists" v-if="$v.dateselection.dateto.$error">
                      <span class="validation-error" v-if="!$v.dateselection.dateto.required">Please Enter to date</span>
                    </div>
                  </li>
                  <li class="list-inline-item align-middle mt-1 mb-1 ">
                    <CButton color="primary" class="px-4" type="submit" :disabled="disable" @click="ChangeDate">Submit</CButton>
                    <CButton color="primary" class="px-4 ml-2" type="button" @click="resetDates();" :disabled="disable">Reset</CButton>
                    <CCol class="col-md-6 float-right">
                      <!-- <CButton color="primary" @click="redirectUrls('/dashboard')" class="px-4 float-right" type="">Back</CButton> -->
                    </CCol>
                  </li>
                </ul>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <loading :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"></loading>
          <v-client-table v-bind:data="resources" v-bind:columns="columns" :options="options" id="dataTable" class="resource-list">
            <!-- <span slot="advertid" slot-scope="props" class="display-link"> {{props.row._id}} </span> -->
            <span slot="fullname" @click="redirectUserDetails('/users-details/'+props.row.userid._id)" slot-scope="props" class="userLink display-link"> {{props.row.firstname}} {{props.row.lastname}} </span>
            <span slot="count" slot-scope="props" class="display-link" title="This much adverts matches with your adverts"> {{props.row.count}} </span>
            <img slot="pic" style="width: 200px; height: 200px;" slot-scope="props" :src="API_URL+'images/' + props.row.pic" @error="$event.target.src = APP_URL+'no_image.png'" />
            <span slot="status" slot-scope="props"> {{props.row.active}} </span>
            <!-- <span slot="createddate" slot-scope="props">{{ moment(props.row.createdAt).format('YYYY-MM-D, h:mm:ss a') }} </span> -->
            <span slot="createddate" slot-scope="props">{{ props.row.createdAt | momentDate }} </span>
            <span slot="action" slot-scope="props">
              <div class="row">
                <div class="col">
                  <button slot="name" class="display-link userLink" @click="redirectUrls('/advert-details/'+props.row._id)" data-toggle="tooltip" data-placement="top" title="View">
                    <font-awesome-icon :icon="['far', 'eye']" />
                  </button>
                </div>
              </div>
            </span>
          </v-client-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'
import Datepicker from 'vuejs-datepicker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const {
    email,
    required,
    maxLength,
	minLength,
	sameAs
} = require("vuelidate/lib/validators");
export default {
    name: 'advertList',
    data() {
        return {
            disable: true,
            showAddBtn: true,
            dateselection: {
              datefrom: "",
              dateto: ""
            },
            disabledDates: {
              // a custom function that returns true if the date is disabled
              // this can be used for wiring you own logic to disable a date if none
              // of the above conditions serve your purpose
              // this function should accept a date and return true if is disabled
              from: new Date(),
            },
            format: 'yyyy-MM-dd',
            isLoading: false,
            dateselection: {
              //datefrom: moment().subtract(7, 'day').format('YYYY-MM-DD') + "T00:00:00.000Z",
              //dateto: moment().format('YYYY-MM-DD') + "T00:00:00.000Z",
              datefrom: localStorage.getItem('advertfromdate'),
              dateto: localStorage.getItem('adverttodate')
            },
            fullPage: true,
            API_URL: API_URL,
            APP_URL: APP_URL,
            resources: [],
            // columns: ['_id', 'pic', 'createddate', 'count', 'action'],
            columns: ['fullname', 'pic', 'createddate', 'status', 'count', 'action'],
            //activeOptions: [{id: 0, text: 'Deactive'}, {id: 1, text: 'Active'}],
            selectedOption: '0',
            token: localStorage.getItem('token'),
            tokenChange: JSON.parse(localStorage.getItem('token')),
            options: {
              sortable: ['firstname'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              },
              filterable: ['firstname', 'lastname'],
              headings: {
                _id: 'Advert id',
                createddate: 'Created Date',
                advertname: 'Advert Name',
                fullname: 'Name'
              },
              texts:{
                filterPlaceholder:"Search",
                filter:"Search",
                count: "Showing {from} to {to} of {count} records"
                // count: "Showing {from} to {to} of {count} records|{count} records|One record"
              },
            }
        }
    },
    components: {
        Loading,
        Datepicker
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    created() {
        document.title = "Advert list";
        this.loadData();
        this.enableDisabled("load");
    },
    methods: {
        loadData() {
            //let datefrom = moment().subtract(7, 'day').format('YYYY-MM-DD') + "T00:00:00.000Z";
            //let dateto = moment().add(1, 'day').format('YYYY-MM-DD') + "T00:00:00.000Z";
            let datefrom = localStorage.getItem('advertfromdate');
            let dateto = localStorage.getItem('adverttodate');
            let postData = {};
            if((datefrom != '' && datefrom != null) && (dateto != '' && dateto != null)) {
              postData = {datefrom:datefrom, dateto:dateto};  
            }
            
            this.isLoading = true;
            axios.post(`${API_ADMIN_URL}/adminMatchingAdvert`, postData, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.resources = response.data.data;
                    this.isLoading = false;
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        },
        moment: function (date) {
          return moment(date);
        },
        ChangeServiceStatus: function(userId) {
            this.isLoading = true;
            axios.post(`${API_ADMIN_URL}/changeActiveStatus/`, {userId: userId}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.loadData();
                    this.showSuccessMsg({message: response.data.message});
                    this.isLoading = false;
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        },
        ChangeDate: function() {
            let datefrom = moment(this.dateselection.datefrom).format('YYYY-MM-DD') + "T00:00:00.000Z";
            //let dateto = moment(this.dateselection.dateto).add(1, 'day').format('YYYY-MM-DD') + "T00:00:00.000Z";
            let dateto = moment(this.dateselection.dateto).format('YYYY-MM-DD') + "T23:59:59.000Z";
            let dateselection = {
                datefrom: datefrom,
                dateto: dateto
            }
            this.isLoading = true;
            axios.post(`${API_ADMIN_URL}/adminMatchingAdvert`, dateselection, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.resources = response.data.data;
                    this.isLoading = false;
                    localStorage.setItem('advertfromdate', datefrom);
                    localStorage.setItem('adverttodate', dateto);
                } else if(response.data.status == 400) {
                    this.resources = [];
                    this.isLoading = false;
                    this.showErrorMsg({message: response.data.message});
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        },
        redirectUrls: function(link) {
            this.$router.push(link);
        },
        redirectUserDetails: function(link) {
          //this.$router.push(link);
          window.open(link, '_blank');
        },
        resetDates: function() {
            this.dateselection.datefrom = '';
            this.dateselection.dateto = '';
            localStorage.removeItem('advertfromdate');
            localStorage.removeItem('adverttodate');
            this.disable = true;
            this.loadData();
        },
        enableDisabled: function(state = ''){
          if(state) {
            if((this.dateselection.datefrom != '' && this.dateselection.datefrom != null) && (this.dateselection.dateto != '' && this.dateselection.dateto != null)) {
              this.disable = false;
            }
            else {
              this.disable = true;
            }
          }
          else {
            this.$nextTick(() => {
              if((this.dateselection.datefrom && this.dateselection.datefrom != '') && (this.dateselection.dateto && this.dateselection.dateto != '')) {
                this.disable = false;
              }
              else {
                this.disable = true;
              }
            });
          }
        }
    },
    mixins: [validationMixin],
    validations: {
        dateselection:{
            datefrom: {
                required,
            },
            dateto: {
                required,
            }
        }
    }
}
</script>
